export default "__VITE_ASSET__b97e39e0__"